/** @format */

import React, { Component } from 'react';
import { Icon, Dropdown, Label, Menu } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import getNotificationText from '../../helpers/getNotificationText';

@inject(
  'UserStore',
  'RequestsStore',
  'ClientsStore',
  'CarPartsStore',
  'CarsStore',
  'SalesStore',
  'NotificationsStore',
)
@observer
class Notifications extends Component {
  renderNotifications = () => {
    const { NotificationsStore, UserStore } = this.props;

    let notificationsList = [];

    if (NotificationsStore.notifications.length > 0) {
      let notifications = NotificationsStore.notifications;
      notificationsList = notifications
        .filter((n, index) => index < 6)
        .map((notification, index) => {
          return (
            <Dropdown.Item
              key={'notification-' + index}
              onClick={() => {
                this.props.history.push(notification.url);
                NotificationsStore.openNotification(
                  notification.id,
                  notification.type,
                );
              }}
              className={
                NotificationsStore.isNew(notification, UserStore.user.uid)
                  ? 'new'
                  : null
              }
            >
              <small>{getNotificationText(notification.type)}</small>
            </Dropdown.Item>
          );
        });
    }
    return notificationsList;
  };

  render() {
    let { NotificationsStore } = this.props;
    return (
      <Menu.Item as="a" name="notification">
        <Dropdown
          icon={<Icon className="notification-icon" name="bell" size="large" />}
          pointing
          className="link item notification-trigger"
        >
          <Dropdown.Menu className="notification-box">
            {this.renderNotifications()}
          </Dropdown.Menu>
        </Dropdown>
        <Label
          className="notifications-num"
          color="red"
          floating
          circular
          size="small"
        >
          {NotificationsStore.newCount}
        </Label>
      </Menu.Item>
    );
  }
}

export default withRouter(Notifications);
